/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// libraries
import React from 'react';
import {
    object, string, shape, bool,
} from 'prop-types';
import Loadable from 'react-loadable';

const PDPDeliveryPopup = Loadable({
    loader: () => import(/* webpackChunkName: "PDPDeliveryPopupContainerV1" */ './v1/PDPDeliveryPopupContainer'),
    loading: () => <div />,
});
const PDPDeliveryPopupV2 = Loadable({
    loader: () => import(/* webpackChunkName: "PDPDeliveryPopupContainerV2" */ './v2/PDPDeliveryPopupContainer'),
    loading: () => <div />,
});

const PDPDeliveryPopupContainer = ({
    brand, productDeliveryType, pageType, isPDPCalendarPopupEnabled, featureFlags, isROSSPassport, isPdpRedesignEnabled, showProductTitleTop, isPlaRedesignEnabled, productBrand, product,
}) => (
    featureFlags['is-pdp-v-2-enabled'] ? (
        <PDPDeliveryPopupV2
            brand={brand}
            productDeliveryType={productDeliveryType}
            pageType={pageType}
            isPDPCalendarPopupEnabled={isPDPCalendarPopupEnabled}
            isROSSPassport={isROSSPassport}
            isPlaRedesignEnabled={isPlaRedesignEnabled}
            productBrand={productBrand}
        />
    ) : (
        <PDPDeliveryPopup
            brand={brand}
            productDeliveryType={productDeliveryType}
            pageType={pageType}
            isPDPCalendarPopupEnabled={isPDPCalendarPopupEnabled}
            isROSSPassport={isROSSPassport}
            isPdpRedesignEnabled={isPdpRedesignEnabled}
            showProductTitleTop={showProductTitleTop}
            isPlaRedesignEnabled={isPlaRedesignEnabled}
            productBrand={productBrand}
            product={product}
        />
    )
);
PDPDeliveryPopupContainer.propTypes = {
    brand: shape({
        domain: string,
    }).isRequired,
    pageType: string,
    productDeliveryType: string.isRequired,
    isPDPCalendarPopupEnabled: bool.isRequired,
    featureFlags: object.isRequired,
    isROSSPassport: bool,
    isPdpRedesignEnabled: bool,
    showProductTitleTop: bool,
    isPlaRedesignEnabled: bool,
    productBrand: string,
    product: object,
};

PDPDeliveryPopupContainer.defaultProps = {
    pageType: '',
    isROSSPassport: false,
    isPdpRedesignEnabled: false,
    showProductTitleTop: false,
    isPlaRedesignEnabled: false,
    productBrand: '',
    product: {},
};

export default PDPDeliveryPopupContainer;
